import { Amplify } from 'aws-amplify';

/**
 * AWS Amplify Configuration
 * 
 * This file configures AWS Amplify for the frontend application,
 * connecting it to Cognito for authentication, API Gateway for data access,
 * and WebSocket for real-time updates.
 * 
 * This is set up to work with both local development and production deployments.
 * In a real production environment, you would replace the placeholder values
 * with the actual values from your AWS CloudFormation outputs.
 */
export const configureAmplify = () => {
  // Environment-specific configurations
  const isLocalDev = window.location.hostname === 'localhost';

  // Using the latest Amplify v6 configuration format
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_example',
        userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || 'example-client-id',
        loginWith: {
          username: true,
          email: true
        }
      }
    },
    API: {
      REST: {
        'location-api': {
          endpoint: process.env.REACT_APP_API_URL || 'https://example-api.execute-api.us-east-1.amazonaws.com/api',
          region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
        }
      }
    }
  });

  // Simplified configuration without token provider customization

  console.log('Amplify configured:', isLocalDev ? 'Development mode' : 'Production mode');
};

/**
 * WebSocket Configuration
 * 
 * Returns the WebSocket URL for real-time updates.
 * In a real deployment, this would be obtained from CloudFormation outputs.
 */
export const getWebSocketUrl = (): string => {
  const isLocalDev = window.location.hostname === 'localhost';
  
  // For development, we can use a local mock WebSocket server or the echo service
  if (isLocalDev) {
    // For testing purposes, you can use the echo WebSocket service
    return process.env.REACT_APP_DEV_WEBSOCKET_URL || 'wss://echo.websocket.org';
  }
  
  // For production, use the WebSocket URL from CloudFormation outputs
  return process.env.REACT_APP_WEBSOCKET_URL || 'wss://example-websocket-api.execute-api.us-east-1.amazonaws.com/prod';
};

/**
 * Map Configuration
 * 
 * Returns configuration options for the OpenStreetMap instance.
 */
export const getMapConfig = () => {
  return {
    defaultCenter: [37.7749, -122.4194], // San Francisco as default
    defaultZoom: 13,
    tileLayer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  };
};
